import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
//import TimePicker from 'react-time-picker';
import ManageCompany from '../../services/manageCompany';
import Utils from "../../utils/utils"

export default class AddIntermediary extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.pageTitle = "Add Company";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const intermediaryType = cookies.get('intermediaryType', { path: '/' });

    this.setState({});
  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'username', numeric: false, disablePadding: true, label: 'Username' },
      { id: 'name', numeric: true, disablePadding: false, label: 'Name' },
      { id: 'surname', numeric: true, disablePadding: false, label: 'Surname' },
    ];

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />
          <TextInput name={'Company name'} value={this.state.companyName} 
            onChange={(text) => { this.setState({companyName: text})}
          } />
          <TextInput name={'Website'} value={this.state.website} 
            onChange={(text) => { this.setState({website: text})}
          } />
          <TextInput name={'Market Cap'} value={this.state.marketCap} 
            onChange={(text) => { this.setState({marketCap: text})}
          } />
          <TextInput name={'Bloomberg number'} value={this.state.bloombergNumber} 
            onChange={(text) => { this.setState({bloombergNumber: text})}
          } />
          <TextInput name={'Sector'} value={this.state.sector} 
            onChange={(text) => { this.setState({sector: text})}
          } />
          <TextInput name={'Country'} value={this.state.country} 
            onChange={(text) => { this.setState({country: text})}
          } />
          <TextInput name={'Pdf Profile'} value={this.state.pdfProfile} 
            onChange={(text) => { this.setState({pdfProfile: text})}
          } />
          <TextInput name={'Representatives (separated by ;)'} value={this.state.rapresentative} 
            onChange={(text) => { this.setState({rapresentative: text})}
          } />
          <TextInput name={'Contact Person'} value={this.state.contactPerson} 
            onChange={(text) => { this.setState({contactPerson: text})}
          } />
          <TextInput name={'Phone Number'} value={this.state.phoneNumber} 
            onChange={(text) => { this.setState({phoneNumber: text})}
          } />
          <TextInput name={'Mobile Number'} value={this.state.mobileNumber} 
            onChange={(text) => { this.setState({mobileNumber: text})}
          } />
          <TextInput name={'eMail Address'} value={this.state.email} 
            onChange={(text) => { this.setState({email: text})}
          } />
          <TextInput name={'Additional eMail address'} value={this.state.additionalMailAddress} 
            onChange={(text) => { this.setState({additionalMailAddress: text})}
          } />
          <TextInput name={'Other e-mail addresses (separated by ;)'} value={this.state.moreEmails} 
            onChange={(text) => { this.setState({moreEmails: text})}
          } />

          <FixButton title={'Save'} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </>
    );
  }

  async save (){
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });
      const intermediaryType = cookies.get('intermediaryType', { path: '/' });
      const currentEventId = cookies.get('currentEventId', { path: '/' });
      const currentBroker = cookies.get('currentBroker', { path: '/' });

      const logo_simple = '';
      const logo = '';
      const web_site = '';

      if (this.state.email != undefined && this.state.email != '' && Utils.validateEmail(this.state.email) == false){
        alert('Check the email address');
        return;
      }

      if (this.state.additionalMailAddress != undefined && this.state.additionalMailAddress != '' && Utils.validateEmail(this.state.additionalMailAddress) == false){
        alert('Check the additional email address');
        return;
      }

      let res = await ManageCompany (username, token, '', currentEventId, currentBroker, 
      this.state.companyName, logo_simple, logo, this.state.marketCap, this.state.sector, this.state.pdfProfile, 
        web_site, this.state.rapresentative, this.state.contactPerson, this.state.phoneNumber,
        this.state.mobileNumber, this.state.email, this.state.additionalMailAddress, this.state.moreEmails, this.state.bloombergNumber, this.state.country, false);
      if (res.result != 'ok'){
        alert ('An error occurred while creating a new intermediary.')
      } else {
        window.location.href = '/#/app/companies';
      }
  }

}

